import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	imageContainer: {
		// width                   : "calc( 33.333% - 6.666px)",
		// height                  : " 200px",
		borderTopLeftRadius     : props?.topLeftFlag ? "5px" : "",
		borderTopRightRadius    : props?.topRightFlag ? "5px" : "",
		borderBottomLeftRadius  : props?.bottomLeftFlag ? "5px" : "",
		borderBottomRightRadius : props?.bottomRightFlag ? "5px" : "",
		backgroundColor         : "black",
		aspectRatio             : "1 / 1",
		cursor                  : "pointer"
	},
	imageStyles: {
		width     : "100%",
		height    : "100%",
		objectFit : "contain"
	}
} ) );
